import React from "react";

const BenifitApp = ({ title, description, image }) => {
  return (
    <div className="border_card">
      <p className="bcard_title">{title}</p>
      <p className="bcard_para">{description}</p>
      <img src={image} className="bcard_img" alt={title} />
    </div>
  );
};

export default BenifitApp;
